import { render } from "./PopupList.vue?vue&type=template&id=6d46244c&scoped=true"
import script from "./PopupList.vue?vue&type=script&lang=js"
export * from "./PopupList.vue?vue&type=script&lang=js"

import "./PopupList.vue?vue&type=style&index=0&id=6d46244c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d46244c"]])

export default __exports__